import styled from 'styled-components';
import { fonts } from 'ui/theme';
import { TextArea } from 'ui/inputs/textArea/TextArea';

export const StyledTextArea = styled(TextArea)`
  cursor: pointer;
  textarea {
    cursor: pointer;
    font-family: ${fonts.monospaced};
  }
`;
